// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compat (desktop-md) */

@media (width >= /* \$screen-md */ 769px) {
  .table-container {
    width: calc(100% + 6rem);
  }

  .table-container-inner {
    min-width: initial;
  }

  .bc-on-github {
    text-align: right;
  }

  .bc-table {
    /* 25% for feature, 75% for browser columns. */
    grid-template-columns: minmax(25%, max-content) repeat(
        var(--compat-browser-count),
        calc(75% / var(--compat-browser-count))
      );
  }

  .icon {
    /* Workaround for Icons being cut by 1px at the top. */
    --size: calc(1rem + 1px);
  }
}
`, "",{"version":3,"sources":["webpack://./components/compat/index-desktop-md.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,8CAA8C;IAC9C;;;OAGG;EACL;;EAEA;IACE,sDAAsD;IACtD,wBAAwB;EAC1B;AACF","sourcesContent":["/* Compat (desktop-md) */\n\n@media (width >= /* $screen-md */ 769px) {\n  .table-container {\n    width: calc(100% + 6rem);\n  }\n\n  .table-container-inner {\n    min-width: initial;\n  }\n\n  .bc-on-github {\n    text-align: right;\n  }\n\n  .bc-table {\n    /* 25% for feature, 75% for browser columns. */\n    grid-template-columns: minmax(25%, max-content) repeat(\n        var(--compat-browser-count),\n        calc(75% / var(--compat-browser-count))\n      );\n  }\n\n  .icon {\n    /* Workaround for Icons being cut by 1px at the top. */\n    --size: calc(1rem + 1px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
